export default __webpack_public_path__ + "static/media/CollapseMenu.30d06c9c.svg";